import Vue from 'vue'
import Router from 'vue-router'
import AdminRouts from '../router/admin'
import PartnerRouts from '../router/partner'
import BusinessRouts from '../router/business'
import WidgetRouts from '../router/widget'

const AdminHome = () => import('@/components/admin/Home')
const PartnerHome = () => import('@/components/partner/Home')
const BusinessHome = () => import('@/components/business/Impact')
const WidgetHome = () => import('@/components/widgets/MainWidget')

Vue.use(Router)
// var routeInterceptor = new Router({
//   mode: 'history',
//   routes: BusinessRouts.concat(WidgetRouts, [
//     {
//       path: '/',
//       name: 'home',
//       components: {
//         business: BusinessHome,
//         widgets: WidgetHome
//       }
//     }
//   ])
// })

let routeInterceptor = new Router({
  mode: 'history',
  routes: AdminRouts.concat(WidgetRouts, PartnerRouts, BusinessRouts, [
    {
      path: '/',
      name: 'home',
      meta: (route) => ({title: 'Home'}),
      components: {
        admin: AdminHome,
        widgets: WidgetHome,
        partner: PartnerHome,
        business: BusinessHome
      }
    }
  ])
})

routeInterceptor.afterEach((toRoute, fromRoute) => {
  // window.document.title = 'Buy1Give1 | ' + toRoute.name.toUpperCase()
  window.document.title = (toRoute.meta.length > 0 && toRoute.meta().title) ? toRoute.meta().title : 'B1G1 | ' + toRoute.name.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase() })
})
export default routeInterceptor



// WEBPACK FOOTER //
// ./src/router/index.js